"use strict";

exports.__esModule = true;
exports.default = exports.config = void 0;

var _classNames = require("../../../utilities/classNames");

var _baseCss = _interopRequireDefault(require("../../../styles/resets/base.css.js"));

var _constants = require("../../../styles/configs/constants");

var _color = require("../../../styles/utilities/color");

var _forEach = _interopRequireDefault(require("../../../styles/utilities/forEach"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var bem = (0, _classNames.BEM)('.c-Icon');
var ICON_SIZES = [8, 10, 12, 13, 14, 16, 18, 20, 24, 32, 48, 52];
var config = {
  caretSize: 12,
  offset: 4,
  size: 20
};
exports.config = config;
var css = "\n  " + _baseCss.default + "\n  color: currentColor;\n  display: block;\n  height: " + config.size + "px;\n  position: relative;\n  width: " + config.size + "px;\n\n  &.is-center {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  &.is-clickable {\n    cursor: pointer;\n  }\n\n  &.is-inline {\n    display: inline-block;\n  }\n\n  &.is-noInteract {\n    pointer-events: none;\n  }\n\n  &.is-offsetLeft {\n    margin-right: " + config.offset + "px;\n  }\n\n  &.is-offsetRight {\n    margin-left: " + config.offset + "px;\n  }\n\n  " + makeShadeStyles() + "\n  " + makeSizeStyles() + "\n  " + makeStateColorStyles() + "\n\n  &.withCaret {\n    " + bem.element('icon') + " {\n      width: calc(100% - " + config.caretSize + "px);\n    }\n  }\n\n  " + bem.element('icon') + " {\n    color: currentColor;\n    display: block;\n    height: 100%;\n    pointer-events: none;\n\n    svg {\n      display: block;\n      height: 100%;\n      max-width: 100%;\n      width: 100%;\n    }\n\n    circle,\n    path,\n    rect {\n      fill: currentColor;\n    }\n\n    &.is-caret {\n      height: " + config.caretSize + "px;\n      position: absolute;\n      right: 0;\n      top: calc(50% - " + Math.round(config.caretSize / 2) + "px);\n      width: " + config.caretSize + "px;\n    }\n  }\n";

function makeShadeStyles() {
  return (0, _forEach.default)(_constants.TEXT_SHADES, function (shade) {
    return "\n    &.is-" + shade + " {\n      color: " + (0, _color.getColor)('text', shade) + ";\n    }\n  ";
  });
}

function makeSizeStyles() {
  return (0, _forEach.default)(ICON_SIZES, function (size) {
    return "\n    &.is-" + size + " {\n      height: " + size + "px;\n      width: " + size + "px;\n\n      &.withCaret {\n        width: " + (size + config.caretSize) + "px;\n      }\n    }\n  ";
  });
}

function makeStateColorStyles() {
  return (0, _forEach.default)(_constants.STATES, function (state) {
    return "\n    &.is-" + state + " {\n      color: " + (0, _color.getColor)('state', state, 'default') + ";\n    }\n  ";
  });
}

var _default = css;
exports.default = _default;